/* eslint-disable jsx-a11y/control-has-associated-label */

interface custom {
  icon: string,
  name: string,
  distCount: number,
  totalCount: number
}
const Protocol = ({
  icon, name, distCount, totalCount,
}: custom) => {
  const imagesProtocol = (x: string) => {
    const protocol = x.includes(' ') ? x.split(' ')[1] : x;
    switch (protocol.toLowerCase()) {
      case 'cardano': return './images/protocols/icons/cardano_icon.svg';
      case 'fabric': return './images/protocols/icons/fabric_icon.svg';
      case 'fluree': return './images/protocols/icons/fluree_icon.svg';
      case 'ethereum': return './images/protocols/icons/ethereum_icon.svg';
      case 'sawtooth': return './images/protocols/icons/sawtooth_icon.svg';
      case 'phaeton': return './images/protocols/icons/phaeton_icon.svg';
      case 'polygon': return './images/protocols/icons/polygon_icon.svg';
      case 'binance': return './images/protocols/icons/binance_icon.svg';
      case 'tron': return './images/protocols/icons/tron_icon.svg';
      case 'avalanche': return './images/protocols/icons/avalanche_icon.svg';
      case 'axia': return './images/protocols/icons/axia_icon.svg';
      case 'fantom': return './images/protocols/icons/fantom_icon.svg';
      case 'polkadot': return './images/protocols/icons/polkadot_icon.svg';
      case 'dcomm': return './images/protocols/icons/dcomm_icon.svg';
      case 'okc': return './images/protocols/icons/okx_icon.svg';
      case 'aptos': return './images/protocols/icons/aptos_icon.svg';
      case 'coreum': return './images/protocols/icons/Coreum_icon.svg';
      case 'polygon-edge': return './images/protocols/icons/polygon_edge_icon.svg';
      case 'shardeum': return './images/protocols/icons/shardeum_icon.svg';
      case 'energy-web': return './images/protocols/icons/energy_web_icon.svg';
      case 'enterprise': return './images/protocols/icons/corda_icon.svg';
      case 'besu': return './images/protocols/icons/besu_icon_logo.svg';
      case 'avalanche-subnets': return './images/protocols/icons/avalanche_icon.svg';
      case 'blockchain': return './images/protocols/icons/provenance_blockchain_icon.svg';
      case 'bahamut': return './images/protocols/icons/fastex_icon.svg';
      case 'zksync': return './images/protocols/icons/zksync_icon.svg';
      case 'parachains': return './images/protocols/icons/parachains_icon.svg';
      case 'opstack': return './images/protocols/icons/opstack_icon.svg';
      case 'orbit': return './images/protocols/icons/arbitrum_orbit_icon.svg';
      case 'arbitrum': return './images/protocols/icons/arbitrum_orbit_icon.svg';
      case 'shido': return './images/protocols/icons/shido_icon.svg';
      case 'subsquid': return './images/protocols/icons/subsquid_icon.svg';
      case 'gnosis-chain': return './images/protocols/icons/gnosis_chain_icon.svg';
      case 'acala': return './images/protocols/icons/acala_icon.svg';
      case 'algorand': return './images/protocols/icons/algorand_icon.svg';
      case 'aurora': return './images/protocols/icons/aurora_icon.svg';
      case 'bitcoin': return './images/protocols/icons/bitcoin_icon.svg';
      case 'base': return './images/protocols/icons/base_icon.svg';
      case 'base-blockchain': return './images/protocols/icons/base_icon.svg';
      case 'corda': return './images/protocols/icons/corda_icon.svg';
      case 'celo': return './images/protocols/icons/celo_icon.svg';
      case 'dogecoin': return './images/protocols/icons/dogecoin_icon.svg';
      case 'etherlink': return './images/protocols/icons/etherlink_icon.svg';
      case 'flow': return './images/protocols/icons/flow_icon.svg';
      case 'fuse': return './images/protocols/icons/fuse_icon.svg';
      case 'cosmos': return './images/protocols/icons/cosmos_icon.svg';
      case 'cronos': return './images/protocols/icons/cronos_icon.svg';
      case 'cross-fi': return './images/protocols/icons/cross_fi_icon.svg';
      case 'harmony': return './images/protocols/icons/harmony_icon.svg';
      case 'hedera': return './images/protocols/icons/hedera_icon.svg';
      case 'hyperledger-besu': return './images/protocols/icons/hyperledger_besu_icon.svg';
      case 'hyperledger-fabric': return './images/protocols/icons/fabric_icon.svg';
      case 'klaytn': return './images/protocols/icons/klaytn_icon.svg';
      case 'kusama': return './images/protocols/icons/kusama_icon.svg';
      case 'lisk': return './images/protocols/icons/lisk_icon.svg';
      case 'moonbean': return './images/protocols/icons/moonbean_icon.svg';
      case 'near': return './images/protocols/icons/near_icon.svg';
      case 'nervos': return './images/protocols/icons/nervos_icon.svg';
      case 'optimism': return './images/protocols/icons/opstack_icon.svg';
      case 'persistence': return './images/protocols/icons/persistence_icon.svg';
      case 'polygon-cdk-chain': return './images/protocols/icons/polygon_cdk_chain_icon.svg';
      case 'provenance_blockchain': return './images/protocols/icons/provenance_blockchain_icon.svg';
      case 'solana': return './images/protocols/icons/solana_icon.svg';
      case 'stacks': return './images/protocols/icons/stacks_icon.svg';
      case 'starknet': return './images/protocols/icons/starknet_icon.svg';
      case 'telos': return './images/protocols/icons/telos_icon.svg';
      case 'tezos': return './images/protocols/icons/tezos_icon.svg';
      case 'ton': return './images/protocols/icons/ton_icon.svg';
      case 'xdc': return './images/protocols/icons/xdc_icon.svg';
      case 'zkevm': return './images/protocols/icons/zkevm_icon.svg';
      case 'zksync-era': return './images/protocols/icons/zksync_icon.svg';
      case 'build': return './images/protocols/icons/build_icon.svg';
      case 'growth': return './images/protocols/icons/growth_icon.svg';
      case 'developer': return './images/protocols/icons/developer_icon.svg';
      case 'launch': return './images/protocols/icons/launch_icon.svg';
      case 'zdfs': return './images/protocols/icons/zdfs.png';
      case 'edge': return './images/protocols/icons/polygon_edge_icon.svg';
      case 'web': return './images/protocols/icons/energy_web_icon.svg';
      case 'chain': return './images/protocols/icons/gnosischain_icon.svg';
      case 'nova': return './images/protocols/icons/arbitrum_nova_icon.svg';
      case 'indexing': return './img/zeeve/subgraph.svg';
      case 'graph': return './img/zeeve/subgraph.svg';
      case 'node': return './img/zeeve/subgraph.svg';
      case 'subquery': return './img/zeeve/subgraph.svg';
      case 'era': return './images/protocols/icons/zksync_icon.svg';
      case 'cdk': return './images/protocols/icons/zkevm_icon.svg';
      case 'subnet': return './images/protocols/icons/avalanche_icon.svg';
      case 'zksyncera': return './images/protocols/icons/zksync_icon.svg';
      case 'beaml1': return './images/protocols/icons/beam_icon.svg';
      case 'l1': return './images/protocols/icons/beam_icon.svg';
      case 'beam': return './images/protocols/icons/beam_icon.svg';
      default: return '';
    }
  };
  return (
      <div className="d-flex mb-4">
          <div className="col-2 mt-2">
              <img src={imagesProtocol(icon)} alt="" width={34} />
          </div>
          <div className="col-6 mx-auto mt-2">
              <p className="mb-1">
                  {' '}
                  <strong>
                      {' '}
                      {name}
                  </strong>
                  {' '}
              </p>
              <div className="progress" style={{ height: 5 }}>
                  <div className="progress-bar" role="progressbar" style={{ width: `${(distCount / totalCount) * 100}%` }} aria-valuenow={(distCount / totalCount) * 100} aria-valuemin={0} aria-valuemax={100} />
              </div>
          </div>
          <div className="col-2 mt-3">
              <h6>{distCount}</h6>
          </div>
      </div>
  );
};
export default Protocol;
